"use strict";
exports.__esModule = true;
exports.chart_axis_grid_Fill = {
  "name": "--pf-chart-axis--grid--Fill",
  "value": "none",
  "var": "var(--pf-chart-axis--grid--Fill, none)"
};
exports["default"] = exports.chart_axis_grid_Fill;